import { useCallback } from 'react';
import { useMutation } from '@apollo/client';
import { gql } from 'graphql-tag';
import { updateUserProfileCertificateNudgesCache } from './updateUserProfileCertificateNudgesCache';

const BULK_REJECT_USER_CERTIFICATE_NUDGE = gql`
  mutation bulkRejectUserCertificateNudge(
    $userUri: String!
    $nudgeIds: [String!]!
  ) {
    bulkRejectUserCertificateNudge(userUri: $userUri, nudgeIds: $nudgeIds) {
      nudges {
        nudgeId
      }
      errors {
        nudge {
          nudgeId
        }
        error
      }
    }
  }
`;

const useBulkRejectUserCertificateNudge = ({ userUri }) => {
  const [bulkRejectUserCertificateNudgeMutation] = useMutation(
    BULK_REJECT_USER_CERTIFICATE_NUDGE,
    {}
  );

  const bulkRejectUserCertificateNudge = useCallback(
    async nudgeIds => {
      return bulkRejectUserCertificateNudgeMutation({
        variables: {
          userUri,
          nudgeIds
        },
        optimisticResponse: {
          bulkRejectUserCertificateNudge: {
            nudges: nudgeIds.map(nudgeId => ({ nudgeId })),
            errors: [],
            __typename: 'UserCertificateNudgesResponse'
          }
        },
        update: (cache, mutationResponse) =>
          updateUserProfileCertificateNudgesCache({
            cache,
            userUri,
            nudgeIds: mutationResponse.data?.bulkRejectUserCertificateNudge.nudges.map(
              nudge => nudge.nudgeId
            )
          })
      });
    },
    [bulkRejectUserCertificateNudgeMutation, userUri]
  );

  return { bulkRejectUserCertificateNudge };
};

export default useBulkRejectUserCertificateNudge;
